import { resolveAvatarUrl } from './avatarUtils';

/**
 * The two identities the board draws while a replay is open, keyed by the
 * side it is being watched from.
 *
 * The board names its seats from `arenaPlayerInfo` / `arenaOpponentInfo`,
 * which the live match fills with the viewer's profile and their matched
 * opponent. A replay reused both verbatim, so the spectated seat carried
 * the VIEWER's own username and the other seat fell back to a placeholder
 * (QA#150). The replay session already knows who sat where (`names`, in
 * seat order) and which Avatar each deck ran (`view.meta.avatars`); the
 * viewpoint decides which of the two is "local".
 *
 * No profile ids: the viewer is not a participant, and a null id keeps
 * the crown / founder badge lookups from claiming their profile for a
 * seat someone else played.
 */
export function replaySeatIdentities(session, sorceryCards) {
  if (!session?.names) return { local: null, remote: null };
  const viewpoint = session.viewpoint === 'p2' ? 'p2' : 'p1';
  const other = viewpoint === 'p1' ? 'p2' : 'p1';
  const avatars = session.view?.meta?.avatars || {};
  const identity = (seat) => ({
    id: null,
    name: session.names[seat] || (seat === 'p1' ? 'Player 1' : 'Player 2'),
    avatarUrl: resolveAvatarUrl({ profileAvatar: avatars[seat]?.cardId || null }, sorceryCards),
  });
  return { local: identity(viewpoint), remote: identity(other) };
}
